/* eslint-disable camelcase */
import { CompositeScreenProps } from "@react-navigation/native"
import OTPInputView from '@twotalltotems/react-native-otp-input'
import { observer } from "mobx-react-lite"
import moment from "moment"
import React, { FC, memo, useCallback, useEffect, useState, useRef } from "react"
import {
  Alert,
  Appearance,
  ImageStyle,
  Linking,
  TextStyle,
  ViewStyle,
  TextInput,
  Platform,
  useWindowDimensions
} from "react-native"
import { View, Toast } from "native-base"
import { AutoImage, Button, FormControl, JalaIcon, PhoneInput, Screen, Text, FormProps, JalaLoading } from "../../../components"
import { presetsLight } from "../../../components/text/text.presets"
import { translate } from "../../../i18n"
import { useStores } from "../../../models"
import { AppStack, LoginStack, ProfileInterest, resetRoot } from "../../../navigators"
import { color } from "../../../theme"
import { createAxios } from "../../../utils/axios"
import config from "../../../utils/config"
import JalaAnalytic from "../../../utils/jala-analytic"
import Icon from 'react-native-vector-icons/MaterialIcons';
import { Field, Formik, FormikProps, FormikValues } from "formik"
import * as yup from "yup"
import { SafeAreaView } from "react-native-safe-area-context"

const verif = require("./verif.png");
const error_verif = require("./otp_error.png")

const ROOT: ViewStyle = {
  flexGrow: 1,
}

const PADDING: ViewStyle = {
  paddingHorizontal: 16,
  // paddingTop:20
}

const IMG_WRAPPER: ViewStyle = {
  alignItems: "center",
}

const IMG_VERIFICATION: ImageStyle = {
  resizeMode: "contain",
  width: '50%',
  height: 200
}

const HEADER: ViewStyle = {
  // marginTop: 30,
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'flex-end',
  paddingHorizontal: 16,
  paddingVertical: 16,
}

const BODY_CONTAINER: ViewStyle = {
  paddingHorizontal: 16,
  paddingTop: 16,
  alignItems: "center",
  justifyContent: "center",
  // flex: 1
}

const OTP_CONTAINER: ViewStyle = {
  height: 44,
}

const OTP_INPUT: TextStyle = {
  ...presetsLight.title1,
  textAlign: "center"
}

const BTN_WRAPPER: ViewStyle = {
  flexDirection: 'row',
  justifyContent: 'center',
}

const FORM_CONTROL: ViewStyle = {
  marginVertical: 20,
}

const BTN_SUBMIT: ViewStyle = {
  marginTop: 48,
  paddingHorizontal: 16,
  paddingBottom: 24,
}

const BOTTOM_BUTTON: ViewStyle = {
  marginTop: 16
}

const BACK_BUTTON: ViewStyle = {
  marginLeft: 16,
  marginRight: 12
}

const { BASE_URL } = config();

export const VerificationHeader: FC<CompositeScreenProps<any, any>> = observer(function VerificationHeader(props){
  const { navigation, route } = props;
  // const [stateScreen, setStateScreen] = useState<boolean>(true);

  const rootStore = useStores();
  const isVerification = !route?.params?.state

  const backIcon = Platform.OS === "ios" ? 'arrow_back_ios' : 'arrow_back';
  const colorScheme = "light"

  const handleLogout = useCallback(() => {
    if (isVerification) {
      rootStore.reset().catch((e) => console.log("ERROR", e))
      resetRoot(LoginStack)
    } else {
      navigation.setParams({ state: undefined })
    }
  }, [isVerification, rootStore, navigation])

  const title = isVerification ? "verificationScreen.phoneVerificationTitle" : "verificationScreen.phoneChangeTitle"

  return (<View backgroundColor={color.primary}>
    <SafeAreaView edges={["top"]} />
    <View flexDirection="row" alignItems="center" paddingY="16px">
      <Button testID="jala:id/back-button" preset="link" textPreset="display1" style={BACK_BUTTON} colorScheme={colorScheme} onPress={handleLogout}>
        <JalaIcon name={backIcon} size={25} color={color.palette.white} />
      </Button>
      <Text text={translate(title)} preset="title2" color={color.palette.white} />
    </View>
  </View>)
})

const ImageVerification: FC<{ isError?: boolean }> = observer(function ImageVerification(props) {
  const { isError } = props
  const imageSource = isError ? error_verif : verif

  return (
    <View style={IMG_WRAPPER}>
      <AutoImage source={imageSource} style={IMG_VERIFICATION} />
    </View>
  )
})


// const LogoutIcon = ({ onPress, colorScheme }: { colorScheme?: "light" | "dark", onPress?: () => void }) => (
//   <Button testID="jala:id/logout-button" accessibilityLabel="logout" preset="link" onPress={onPress} colorScheme={colorScheme}>
//     <JalaIcon name="logout" size={24} color={color.palette.darkestGrey} />
//   </Button>
// )

// const CloseIcon = ({ onPress, colorScheme, expired, logout }: { colorScheme?: "light" | "dark", onPress?: () => void, expired?: () => any, logout?: () => void }) => {
//   const { isExpired } = expired();
//   return ( isExpired ? <LogoutIcon onPress={logout} /> :
//     <Button testID="jala:id/close-button" accessibilityLabel="close_modal" preset="link" onPress={onPress} colorScheme={colorScheme} >
//       <JalaIcon name="close" size={25} />
//     </Button>
//   )
// }

// const BodyVerification = ({ timer, hasLogin, number, phone, user, colorScheme, onContactPress, getDaysExpired }
//   : { timer?: number, hasLogin?: boolean, number?: any,   }) => {
//   // const hasLogin = true;
//   const isActive = timer !== 0;
//   const valueTimer = timer <= 0 ? `${translate('verificationScreen.cantVerify')}${translate('verificationScreen.contactUs')}` : translate('verificationScreen.inputBeforeExpired', { seconds: timer });
//   const subtitle = hasLogin ? translate("verificationScreen.subtitle", { phone: ''}) : translate("verificationScreen.subtitleOld", { phone: '' });
//   const phoneNumber = number || phone || (user || {}).phone || null;
//   const { days, hours, isExpired } = getDaysExpired();
//   const isExpiredInfo = isExpired ? translate('verificationScreen.verifExpired') : translate('verificationScreen.warningOld', { day: days, hour: hours });
//   const info = hasLogin ? isExpiredInfo : translate('verificationScreen.verificationInfo');
//   // const infoColor = Colors.grey700;
//   const disabled = timer > 0;

//   return (
//     <View style={BODY_CONTAINER}>
//       <Text preset="display2" tx="verificationScreen.title" colorScheme={colorScheme} />
//       <Text preset="body3" text={subtitle} colorScheme={colorScheme} marginBottom={2}  />
//       <Text preset="title2" text={phoneNumber} colorScheme={colorScheme} />
//       <Text preset="body3" text={info} color={color.palette.grey} colorScheme={colorScheme} marginTop={2} />
//       {/* <OTPInput /> */}
//       <View style={BTN_WRAPPER}>
//         <Button testID="jala:id/resend-button" accessibilityLabel="resend_otp" disabled={disabled} preset="link" onPress={onContactPress}>
//           <Text preset="title3" color={isActive ? color.palette.blueJalaLight : color.primary} text={valueTimer} />
//         </Button>
//       </View>
//     </View>
//   )
// }

const OTPInput: FC<{
  colorScheme?: "light"|"dark",
  errors?: any,
  handleChangeOTP?: (value: string) => void
}> = memo(function OTPInput(props) {
  const {
    colorScheme = "light" || Appearance.getColorScheme(),
    errors, handleChangeOTP
  } = props
  return (
    <FormControl
      testID="jala:id/otp-input"
      isRequired
      labelPreset="title3"
      colorScheme={colorScheme}
      errorMessage={!!errors && translate("verificationScreen.codeVerificationError")}
      style={FORM_CONTROL}
    >
      <OTPInputView
        style={OTP_CONTAINER}
        pinCount={6}
        onCodeChanged={handleChangeOTP}
        codeInputFieldStyle={OTP_INPUT}
        keyboardAppearance={colorScheme}
        autoFocusOnLoad={false}
      />
    </FormControl>
  )
})


const VerificationInfo: FC<{ colorScheme?: "light"|"dark", hasLogin?: boolean, number?: string, isErrorOTP?: boolean, phone?: string }> = observer(function VerificationInfo(props) {
  const { colorScheme = "light" || Appearance.getColorScheme(), hasLogin, isErrorOTP } = props

  const rootStore = useStores();
  const { userStore: { user } } = rootStore;

  const title = isErrorOTP ? translate("verificationScreen.verificationFailed") : translate("verificationScreen.title")
  const subtitle = hasLogin ? translate("verificationScreen.subtitle", { phone: ''}) : translate("verificationScreen.subtitleOld", { phone: '' });
  const isErrorSubtitle = isErrorOTP ? translate("verificationScreen.OTPLimited") : subtitle
  const phoneNumber = user?.phone;

  return (
    <>
      <Text preset="display2" textAlign="center" text={title} colorScheme={colorScheme} color={color.primaryDarker} />
      <Text preset="body3" textAlign="center" text={isErrorSubtitle} colorScheme={colorScheme} marginBottom={2} marginTop="8px"  />
      {!isErrorOTP && <Text preset="title2" textAlign="center" text={phoneNumber} colorScheme={colorScheme} />}
    </>
  )
})

const TimerButton : FC<{ colorScheme?: "light"|"dark", expiredAt?: string, setTimerOn?: () => void, getOTP?: () => void }> = observer(function VerificationInfo(props) {
  const { colorScheme = "light" || Appearance.getColorScheme(), expiredAt, setTimerOn, getOTP } = props
  const [timer, setTimer] = useState<number>(0);
  useEffect(() => {
    // PROBLEM HERE .....
    // console.log("COMPONENT DID UPDATE DOUBLE !! ===> ", !!expiredAt, expiredAt)
    // if (prevState.current !== expiredAt) {
    if (expiredAt) {
      let timeLeft = moment.utc(expiredAt).diff(moment.utc(), 'seconds');
      if (timeLeft <= 0) {
        timeLeft = 0;
        setTimerOn()
      }

      const intervalId = setInterval(() => {
        setTimer(timeLeft - 1);
      }, 1000);
      return () => clearInterval(intervalId);
    }
    return () => timer;
  }, [expiredAt, setTimerOn, timer])

  const valueTimer = timer <= 0 ? translate('verificationScreen.resendOTP') : `${timer}`;

    return (
      <View alignSelf="flex-end">
        <Button testID="jala:id/resend-button" accessibilityLabel="resend_otp" preset="link" onPress={getOTP} disabled={timer > 0}>
          <Text colorScheme={colorScheme} text={valueTimer} preset="title4" color={color.primary} />
        </Button>
      </View>
    )
  })

export interface PhoneBodyProps extends FormProps {
  initialValues?: { phone?: string }, hasPhone?: boolean, is24HoursOld?: boolean
}

const PhoneBody = observer(function PhoneBody(props: PhoneBodyProps) {
  const { initialValues = {}, colorScheme = "light" || Appearance.getColorScheme(), hasPhone, onSubmit, is24HoursOld,  innerRef, ...rest  } = props

  const input = { phone: useRef<TextInput>() }

  const onTouchPhoneInput = useCallback(() => {
    if (!is24HoursOld) Toast.show({
      title: translate('verificationScreen.phoneWarning'),
      placement: 'top',
    })
  }, [is24HoursOld])

  const validationSchema = yup.object({
    phone: yup.string().ascii().max(15, translate("verificationScreen.phoneError")).nullable()
  })

  const titleDisclaimer = is24HoursOld ? translate("registerScreen.phoneDisclaimer") : translate("verificationScreen.phoneDisclaimer")
  return (
    <View style={PADDING}>
      <View background={color.palette.orange300} py="12px" px="16px" mx="-16px" mb="12px" flexDirection="row">
        <Icon name="info-outline" size={18} color={color.palette.gray800} />
        <Text text={titleDisclaimer} ml="10px" mr="20px" preset="body3" color={color.palette.gray800} colorScheme={colorScheme} numberOfLines={3} textAlign="justify" />
      </View>
      <Formik
        initialValues={{ ...initialValues }}
        validationSchema={validationSchema}
        onSubmit={onSubmit}
        innerRef={innerRef}
        {...rest}
      >
      {({ isValid, handleSubmit, values, initialValues }) => (
        <>
          <Field name="phone">
            {({ field, form: { handleChange, handleBlur }, meta }) => (
              <FormControl
                accessibilityLabel="change_phone"
                isRequired
                labelPreset="title3"
                colorScheme={colorScheme}
                errorMessage={meta.error}
                isInvalid={!!meta.error}
                onTouchStart={onTouchPhoneInput}
              >
                <PhoneInput
                  colorScheme={colorScheme}
                  isInvalid={!!meta.error}
                  textProps={{
                    testID: `jala:id/phone-input`,
                    ref: input[field.name],
                    defaultValue: meta.initialValue,
                    value: values[field.name],
                    autoCapitalize: "none",
                    autoComplete: "tel",
                    textContentType: "telephoneNumber",
                    onSubmitEditing: () => isValid && handleSubmit(),
                    color: is24HoursOld ? color.palette.gray800 : color.palette.gray500
                  }}
                  onChangePhoneNumber={handleChange(field.name)}
                  disabled={!is24HoursOld}
                />
              </FormControl>
            )}
          </Field>
        </>
      )}
      </Formik>
    </View>
  )
})

export const VerificationScreen: FC<{ colorScheme?: "light" | "dark" } & CompositeScreenProps<any, any>> = observer(function VerificationScreen(props) {
  const { colorScheme = "light" || Appearance.getColorScheme(), route: { params: { phone = '' } = {} }, navigation, route } = props

  // Pull in one of our MST stores
  const rootStore = useStores();
  const { userStore, userStore: { user } } = rootStore;

  const [expiredAt, setExpired] = useState<any>(null);
  const [errors, setErrors] = useState<boolean>(false);
  const [hasPhone, setHasPhone] = useState<boolean>(true);
  const [otp, setOtp] = useState<string>("");
  const [number, setPhone] = useState<string>(null);
  const [loading, setLoading] = useState<boolean>(false);
  const [errorOTP, setErrorOTP] = useState<boolean>(false);
  const [isTimerOn, setIsTimerOn] = useState<boolean>(true);

  const { height } = useWindowDimensions();

  const phoneBody = useRef<FormikProps<FormikValues>>()
  const phoneBodyRef = useCallback((node) => {
    phoneBody.current = node;
    // if (phoneBody.current) setIsError(!(phoneBody.current.dirty && phoneBody.current.isValid))
  }, [])

  const isVerification = !route?.params?.state;

  const setIsVerification = useCallback((isVerification) => {
    navigation.setParams({ state: !isVerification ? 1 : undefined })
  }, [navigation])

  useEffect(() => {
    const phoneNumb = number || phone || (user || {}).phone || null;
    if (phoneNumb) getOTP();
    checkHasPhone();
    mixPanelEvent();
  }, [number, phone, user])

  // useEffect(() => {
  //   const interval = setInterval(() => {
  //     const timeLeft = moment.utc(expiredAt).diff(moment.utc(), 'seconds');
  //     if (timeLeft > 0) {
  //       // Calculate the remaining seconds
  //       setTimer(timeLeft - 1);
  //     } else {
  //       // Timer has expired
  //       setTimer(0);
  //       setIsTimerOn(false)
  //       clearInterval(interval);
  //     }
  //   }, 1000);

    // Clean up the interval on component unmount
  //   return () => {
  //     clearInterval(interval);
  //   };
  // }, [expiredAt]);


  // useEffect(() => {
  //   navigation.setParams({state: isVerification })
  // }, [isVerification])

  const getOTP = useCallback(() => {
    setErrorOTP(false)
    if (user) JalaAnalytic.log('Mobile app: verification - send OTP', { email: user.email, phone: phone || user.phone })
    createAxios().post('verify_phone/resend')
      .then((response) => {
        const { expired_at } = response.data;
        setExpired(expired_at || moment.utc().format('YYYY-MM-DD HH:mm:ss'));
        setIsTimerOn(true);
        console.log("===== RESPONSE GET OTP =====")
      })
      .catch((e) => {
        if (e.response && (e.response.data || {}).is_code_exist) {
          const { expired_at, message } = e.response.data;
          Alert.alert('Error', message, [{ text: 'OK' }]);
          setExpired(expired_at || moment.utc().format('YYYY-MM-DD HH:mm:ss'));
        } else {
          if (e.response && e.response.status === 403) setErrorOTP(true)
          setExpired(null);
        }
      })
  }, [phone, user]);

  const mixPanelEvent = () => {
    return isVerification
      ? JalaAnalytic.log('Mobile app: verification - visit confirm OTP')
      : JalaAnalytic.log('Mobile app: verification - visit insert phone number');
  }

  const checkHasPhone = () => {
    const hasPhone = number || phone || (user || {}).phone || null;
    if (!hasPhone) {
      setIsVerification(false);
      setHasPhone(false);
    }
  }

  const checkIf24HoursOld = useCallback(() => {
    const isRegistered = !user?.state?.phone_updated_at
    const twentyFourHoursInMilliseconds = 24 * 60 * 60 * 1000
    const currentDateTime = new Date()

    const dateTime = user && user?.state?.phone_updated_at && new Date(user?.state?.phone_updated_at)
    const timeDifference = dateTime ? currentDateTime.getTime() - dateTime.getTime() : 0;
    if (isRegistered) return true
    else return timeDifference >= twentyFourHoursInMilliseconds;
  }, [user]);

  // Example usage
  // const getDaysExpired = useCallback(() => {
  //   // const exp = (user || {}).state.phone_verification_expired_at;
  //   const exp = user ? user.state.phone_verification_expired_at : moment();
  //   const today = moment();
  //   const expiredDate = moment(exp).utc().local();
  //   const diffTime = Math.abs(expiredDate.unix() - today.unix());
  //   const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));
  //   const isExpired = expiredDate.isBefore(today);
  //   const hours = Math.floor(diffTime / (1000 * 60 * 60)) - (diffDays * 24);
  //   const days = diffDays < 0 ? 0 : diffDays;
  //   return { days, hours, isExpired };
  // }, [user])


  const handleChange = useCallback((value, key = "phone") => {
    if (key === "OTP") {
      setErrors(false);
      setOtp(value);
    }
    else setPhone(value)
  }, [])

  const handleChangeOTP = useCallback((value) => (
    handleChange(value, "OTP")
  ), [handleChange]);

  const onContactPress = useCallback(() =>  {
    const phoneNumber = number || phone || (user || {}).phone || null;
    const message = hasPhone
      ? translate('verificationScreen.whatsappMessageVerification', { phoneNumber })
      : translate('verificationScreen.whatsappMessageVerificationEmail', { email: user.email });
    const link = `https://api.whatsapp.com/send/?phone=6281325514194&text=${message}&app_absent=0`;
    Linking.openURL(link).catch();
    JalaAnalytic.log('Mobile app: verification - contact us clicked');
  }, [hasPhone, number, phone, user])

  const handleSubmit = useCallback(() => {
    setLoading(true);
    createAxios().post('verify_phone', {
      testing: __DEV__ || (BASE_URL || "").includes('staging') || undefined,
      code: otp
    }).then((res) => {
      if(res.status === 200) {
        userStore.set('user', {...user, phone_verified: true});
        JalaAnalytic.log('Mobile app: verification - verification succeed', { email: user.email, phone: phone || user.phone || null })
        userStore.syncUser().then(() => {
          setLoading(false);
          return !user.interest && (!user.interests || !user.interests.length) ? resetRoot(ProfileInterest) : resetRoot(AppStack);
        })
      }
      return res;
    }).catch(error => {
      handleChangeOTP('')
      setErrors(true);
      setLoading(false);
      JalaAnalytic.log('Mobile app: verification - verification failed', { email: user.email, phone: phone || user.phone || null })
      if (error.response) {
        Alert.alert('Error', error.response.data.message, [{ text: 'OK', onPress: () => setErrors(false) }]);
      } else {
        Alert.alert('Error', error.message, [{ text: 'OK', onPress: () => setErrors(false) }]);
      }
    });
  }, [handleChangeOTP, otp, phone, user, userStore])

  const handleChangeNumber = useCallback(({ event }) => {
    if (phoneBody.current) phoneBody.current.handleSubmit(event)
  }, [])

  const onSubmitPhone = useCallback(({ phone }) => {
    const param = { phone };
    setLoading(true);
    userStore.updateData(param).then(() =>
      userStore.syncUser().then(() =>
        userStore.getUser(false)).then(() => {
        setIsVerification(true);
        setHasPhone(true);
        setLoading(false);
      })
    ).catch((error) => {
      setLoading(false);
      if (error.response) {
        if (error.response.status === 422) {
          const message = error.response.data.errors.phone[0];
          Alert.alert('Error', message, [{ text: 'OK' }]);
        } else {
          Alert.alert('Error', (error.response.data || {}).message || error.message, [{ text: 'OK' }]);
        }
      } else {
        Alert.alert('Error', error.message, [{ text: 'OK' }]);
      }
    });
  }, [setIsVerification, userStore])

  const handleChangeScreen = useCallback(() => {
    setIsVerification(!isVerification)
  }, [isVerification, setIsVerification])

  const Header = useCallback(() => {
    const title = isVerification ? translate("verificationScreen.changePhone") : translate("verificationScreen.verification");
    const colour = !isTimerOn ? color.primary : color.palette.gray500;
    return (
      <View style={HEADER}>
        {hasPhone && !(errorOTP && isVerification) && <Button testID="jala:id/action-button" accessibilityLabel="change_display" preset="link" textColor={colour} textPreset="title3" text={title} disabled={isTimerOn} colorScheme={colorScheme} onPress={handleChangeScreen} />}
      </View>
    )
  },[colorScheme, errorOTP, handleChangeScreen, hasPhone, isTimerOn, isVerification])

  const ContactButton = useCallback(() => (
    !loading && isVerification && !errorOTP && <View style={BTN_WRAPPER}>
      <Text preset="title4" textAlign="center" colorScheme={colorScheme} tx="verificationScreen.cantVerify" />
      <Button testID="jala:id/contact-button" accessibilityLabel="contact_support" preset="link" onPress={onContactPress}>
        <Text tx="verificationScreen.contactUs" preset="title4" textAlign="center" color={color.primary} />
      </Button>
    </View>
  ), [colorScheme, errorOTP, isVerification, loading, onContactPress])

  const CountDownTimer = useCallback(() => {
    return <TimerButton expiredAt={expiredAt} colorScheme={colorScheme} setTimerOn={() => setIsTimerOn(false)} getOTP={getOTP} />
  }, [colorScheme, expiredAt, getOTP])

  const BodyVerification = useCallback(() => {
    return (
      <View style={BODY_CONTAINER}>
        <VerificationInfo colorScheme={colorScheme} isErrorOTP={errorOTP} />
        {!errorOTP && <OTPInput
          colorScheme={colorScheme}
          handleChangeOTP={handleChangeOTP}
          errors={errors}
        />}
        {!errorOTP && <CountDownTimer />}
      </View>
    )
  }, [CountDownTimer, colorScheme, errorOTP, errors, handleChangeOTP])

  const BodyChangePhone = useCallback(() => {
    return <PhoneBody initialValues={{ phone: user ? user.phone : '' }} hasPhone={hasPhone} onSubmit={onSubmitPhone} innerRef={phoneBodyRef} is24HoursOld={checkIf24HoursOld()} />
  }, [checkIf24HoursOld, hasPhone, onSubmitPhone, phoneBodyRef, user])

  const ImageVerifivation = useCallback(() => (
      isVerification && <ImageVerification isError={errorOTP} />
  ), [errorOTP, isVerification])

  const SubmitButton = useCallback(() => {
    const isDisabled = isVerification && String(otp || '').length < 6;
    const is24HoursOld = checkIf24HoursOld();
    const hasPhoneButton = !hasPhone ? translate("verificationScreen.inputPhoneTitle") : translate("verificationScreen.changeNumberButton");
    const is24HoursButton = is24HoursOld ? hasPhoneButton : translate('verificationScreen.contactUs')
    const title = isVerification ? translate("verificationScreen.verificationButton") : is24HoursButton;
    const contactOrChange = is24HoursOld ? handleChangeNumber : onContactPress
    const submit = isVerification ? handleSubmit : contactOrChange;
    return ((!isVerification || !loading) &&
      <View style={BTN_SUBMIT}>
        <Button testID="jala:id/send-button" accessibilityLabel="verification_send" text={title} textPreset="title3" disabled={isDisabled} loading={loading} colorScheme={colorScheme} onPress={submit} />
      </View>
    )
  }, [checkIf24HoursOld, colorScheme, handleChangeNumber, handleSubmit, hasPhone, isVerification, loading, onContactPress, otp])

  const ErrorOTPButton = useCallback(() => (
    !loading &&
    <View paddingX="16px" marginTop="28px">
      <Button testID="jala:id/error-otp-change-number-button" accessibilityLabel="verification_send" tx="verificationScreen.changePhone" textPreset="title3" colorScheme={colorScheme} onPress={handleChangeScreen} />
      <Button testID="jala:id/err-otp-contact-button" accessibilityLabel="verification_send" tx="verificationScreen.contactUs" textPreset="title3" colorScheme={colorScheme} onPress={onContactPress} style={BOTTOM_BUTTON} preset="outline" />
    </View>
  ), [colorScheme, handleChangeScreen, loading, onContactPress])

  const VerificationContent = useCallback(() => {
    return (loading
      ? <View flexGrow={1} alignItems="center" justifyContent="center" height={`${height - 216}px`}>
          <JalaLoading />
        </View>
      : <>
          <Header />
          <ImageVerifivation />
          <BodyVerification />
        </>
    )
  }, [BodyVerification, Header, ImageVerifivation, height, loading])

  return (
    <Screen
      style={ROOT}
      preset="scroll"
      colorScheme={colorScheme}
      backgroundColor={colorScheme === "light" ? color.palette.white : undefined}
      backgroundBar={colorScheme === "light" ? color.primary : undefined}
      statusBar={colorScheme === "light" ? "light-content" : "dark-content"}
    >
      { isVerification ? <VerificationContent /> : <BodyChangePhone /> }
      { isVerification && errorOTP ? <ErrorOTPButton /> : <SubmitButton /> }
      <ContactButton />
    </Screen>
  )
})
